'use client';

import { useHits, usePagination, useStats } from 'react-instantsearch';
import EventCardNew from './EventCardNew';

interface EventsListNewProps {
  dict: any;
}

export default function EventsListNew({ dict }: EventsListNewProps) {
  const { hits } = useHits();
  const { currentRefinement, nbPages, refine } = usePagination();
  const { nbHits, hitsPerPage } = useStats();
  
  // Default to 12 if hitsPerPage is undefined
  const itemsPerPage = hitsPerPage || 12;

  const handlePageChange = (page: number) => {
    refine(page);
    // Scroll to top of results
    if (typeof window !== 'undefined') {
      const section = document.querySelector('.calender-sec');
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <section className="calender-sec">
      <div className="container">
        <div className="row">
          {/* Display Algolia event results */}
          {hits.length > 0 ? (
            <>
              {hits.map((hit: any) => (
                <EventCardNew key={hit.objectID} hit={hit} dict={dict} />
              ))}
            </>
          ) : (
            <div className="col-12 text-center py-5">
              <p>No events found. Try adjusting your search criteria.</p>
            </div>
          )}

          {/* Pagination */}
          {hits.length > 0 && nbPages > 0 && (
            <div className="col-lg-12">
              <div className="pagination-bar">
                <div className="result">
                  <p>
                    Showing {currentRefinement * itemsPerPage + 1} - {Math.min((currentRefinement + 1) * itemsPerPage, nbHits)} of {nbHits} results
                  </p>
                </div>
                <nav aria-label="Page navigation">
                  <ul className="pagination">
                    {/* Generate page numbers - show first 3 pages */}
                    {Array.from({ length: Math.min(nbPages, 3) }, (_, i) => i).map((pageIndex) => (
                      <li 
                        key={pageIndex} 
                        className={`page-item ${currentRefinement === pageIndex ? 'active' : ''}`}
                      >
                        <a 
                          className="page-link" 
                          href="#" 
                          onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(pageIndex);
                          }}
                        >
                          {pageIndex + 1}
                        </a>
                      </li>
                    ))}
                    
                    {/* Next button - single chevron */}
                    {currentRefinement < nbPages - 1 && (
                      <li className="page-item next-btn">
                        <a 
                          className="page-link" 
                          href="#" 
                          aria-label="Next"
                          onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(currentRefinement + 1);
                          }}
                        >
                          <span className="single">
                            <i className="bi bi-chevron-right"></i>
                          </span>
                        </a>
                      </li>
                    )}
                    
                    {/* Last page button - double chevron */}
                    {currentRefinement < nbPages - 1 && (
                      <li className="page-item next-btn">
                        <a 
                          className="page-link" 
                          href="#" 
                          aria-label="Last"
                          onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(nbPages - 1);
                          }}
                        >
                          <span className="double">
                            <i className="bi bi-chevron-double-right"></i>
                          </span>
                        </a>
                      </li>
                    )}
                  </ul>
                </nav>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
